export const messageChannels = { sms: 'sms', mail: 'mail' } as const
export const messagingStatuses = {
  accepted: 'accepted',
  sending: 'sending',
  held: 'held',
  cancelled: 'cancelled',
  retryRequested: 'retry_requested',
  unknown: 'unknown',
  notSent: 'not_sent',
} as const
export const protectionDecisions = { allow: 'allow', wouldPause: 'would_pause', wouldBlock: 'would_block' } as const
export const protectionVerdicts = {
  correct: 'correct',
  falsePositive: 'false_positive',
  uncertain: 'uncertain',
} as const
export const twilioOutcomes = {
  pumpingBlocked: 'pumping_blocked',
  delivered: 'delivered',
  otherFailure: 'other_failure',
  pending: 'pending',
} as const
export const releaseStatuses = { monitoring: 'monitoring' } as const
export const protectionPageSize = 50

export const protectionTimezone = 'Europe/Stockholm'
